import type { DIAMError, ErrorResponse } from '~/types/error-responses.types';
import type { ParsedResponse } from '../types/types';
import { DIAMException, ErrorResponseException, NotFoundException } from '../errors';

export const isUnauthenticatedError = (res) => {
  return res?.status === 401;
};
export const isDiamError = (json): json is ErrorResponse<DIAMError> => {
  return (
    json?.errors &&
    json.errors.length > 0 &&
    json.errors[0].status &&
    json.errors[0].detail &&
    json.errors[0].title
  );
};

export default ([res, json]: ParsedResponse) => {
  if (res.ok) {
    return json;
  }

  //If the endpoint did not exist
  if (res.status === 404 && typeof json.errors === 'undefined') {
    throw new NotFoundException({
      errors: [
        {
          status: 404,
          id: 'web.error.resource_not_found',
          description: 'web.error.resource_not_found',
        },
      ],
    });
  }

  if (isDiamError(json)) {
    throw new DIAMException(json);
  }

  if (isUnauthenticatedError(res)) {
    throw new ErrorResponseException({
      errors: [
        {
          status: 401,
          description: 'web.error.session_expired',
        },
      ],
    });
  }

  throw new ErrorResponseException(json);
};
